import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import ReactSwiper from 'react-id-swiper'
import ReactHtmlParser from 'react-html-parser'
import LinesEllipsis from 'react-lines-ellipsis'
import responsiveHOC from 'react-lines-ellipsis/lib/responsiveHOC'
import cloudinary from 'helpers/cloudinary'
// Ant Design
import { Flex, ActivityIndicator, Badge } from 'antd-mobile'

// Lodash
import * as _ from 'lodash'
import lang from 'lodash/lang'
import collection from 'lodash/collection'
import object from 'lodash/object'
import array from 'lodash/array'

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle, faUndo } from '@fortawesome/free-solid-svg-icons'

// JSS
import cx from 'classnames'
import injectSheet from 'react-jss'
import styles from '../assets/styles/components/CategoryDetailList'

// Components
import StepperContainer from '../containers/components/Stepper'
import CarouselContainer from '../containers/components/Carousel'
import AboutContainer from '../containers/components/About'
import GridContainer from '../containers/components/Grid'
import WaiterStepperContainer from '../containers/components/WaiterStepper'
import { IPHONEX_WIDTH } from '../constants/mediaQuery'

const ResponsiveEllipsis = responsiveHOC()(LinesEllipsis)

class CategoryDetailList extends Component {
  isLoadedMenu = false;

  constructor (props) {
    super(props)
    this.state = {
      category: null,
      step: null,
      topOfClientRect: undefined,
      isSticky: false,
      isRendered: false,
      searchText: '',
    }
    this.defaultItemNameHeight = 16 // 1 line 's height and default 14px font-size
    this.wrapRef = React.createRef()
    this.searchInputRef = React.createRef()
  }

  // restore previous selection
  compareMatchesAndAction (match, nextMatch) {
    const {
      merchant,
      isTakeaway,
      categories,
      selectedTag,
      getCategories,
      getMenus,
      getTags,
      selectTag,
      resetStash,
      menusCache,
      query,
    } = this.props

    if (!merchant) return

    const prevCatId = match.params ? match.params.id : ''
    const catId = nextMatch.params ? nextMatch.params.id : ''
    const prevTag = match.params ? match.params.tag : ''
    const tag = nextMatch.params ? nextMatch.params.tag : ''

    // restore selected tag
    if (!selectedTag && tag) {
      selectTag({
        name: tag,
      })
    }
    const pkg = _.get(query, 'params.pkg')

    if (!this.isLoadedMenu || prevCatId !== catId || prevTag !== tag || menusCache.forceRefreshMenu) {
      this.isLoadedMenu = true
      resetStash()
      try {
        getMenus({
          merchantId: merchant.id,
          categoryId: catId,
          tag: tag,
          isSet: (nextMatch.path.indexOf('set') >= 0),
          isTakeaway: isTakeaway,
          datetime: this.props.form.datetime,
          forceRefreshMenu: menusCache.forceRefreshMenu,
        })
        getCategories(merchant.id, (pkg || '').split(','), this.props.form.datetime)
        if (!catId) {
          getTags(merchant.id, 'zh')
        }
      } catch (err) {
        this.isLoadedMenu = false
      }
    }

    if (!categories) return

    let selectedCat = null
    categories.some((cat) => {
      if (cat.id === catId) {
        selectedCat = cat
        return true
      }
      selectedCat = cat.categories.find((subCat) => subCat.id === catId)
      return Boolean(selectedCat)
    })

    // restore selected category
    if (selectedCat !== this.state.category) {
      this.setState({
        category: selectedCat,
      })
    }

    // restore selected set steps
    if (selectedCat && selectedCat.isSet && selectedCat.steps.length) {
      let activeStep
      const activeStepKey = nextMatch.params ? nextMatch.params.step : ''
      if (activeStepKey) {
        activeStep = selectedCat.steps.find((step) => step.key === activeStepKey)
      } else {
        activeStep = selectedCat.steps[0]
      }
      if (this.state.step !== activeStep) {
        this.setState({
          step: activeStep,
        })
      }
    } else {
      if (this.state.step !== null) {
        this.setState({
          step: null,
        })
      }
    }
  }

  componentDidMount = () => {
    const {
      match,
      orders,
      history,
    } = this.props

    this.compareMatchesAndAction({}, this.props.match)

    if (object.has(match.params, 'step')) {
      const _order = collection.find(orders, (order, key) => {
        return (order.dishId === match.params.id) && (order.confirmed === false)
      })

      if (_order) {
        const menuIndex = this.getMenuIndex(_order)
        const path = `/category/set/${match.params.id}/${_order.steps[menuIndex].key}`
        history.push(path)
        console.info('route changed', path)
      }
    }
  }

  componentWillUnmount = () => {
    const { isStickyNavbarSwiper } = this.props
    window.removeEventListener('scroll', this.handleScroll)
    isStickyNavbarSwiper(false)
  };

  handleScroll = () => {
    const {
      isStickyNavbarSwiper,
      bannerImgHeight,
    } = this.props

    if (window.scrollY > this.state.topOfClientRect + bannerImgHeight) {
      if (!this.state.isSticky) {
        isStickyNavbarSwiper(true)
        this.setState({
          isSticky: true,
        }, () => {
          this.wrapRef.current.style.position = 'fixed'
          this.wrapRef.current.style.top = '50px'
          this.wrapRef.current.style.zIndex = 9
        })
      }
    } else {
      if (this.state.isSticky) {
        isStickyNavbarSwiper(false)
        this.setState({
          isSticky: false,
        }, () => {
          this.wrapRef.current.style.position = 'static'
          this.wrapRef.current.style.top = ''
          this.wrapRef.current.style.zIndex = ''
        })
      }
    }
  };

  getMenuIndex = (item) => {
    let currentIndex = 0
    if (item) {
      const _itemStep = item.steps
      collection.find(_itemStep, (_step, index) => {
        currentIndex = index
        if (_step.min <= 0 && _step.quantity === 1) {
          return false
        }
        if (_step.quantity !== 0) {
          return _step.quantity < _step.min
        }

        return true
      })
    }
    return currentIndex
  };

  getSwiperStepIndex = (item) => {
    const {
      match,
    } = this.props

    const _item = item
    const currentIndex = array.findIndex(_item.steps, (i) => {
      return i.key === match.params.step
    })
    return currentIndex
  };

  componentDidUpdate = (prevProps) => {
    const {
      match,
      orders,
      history,
    } = this.props

    // getMenus
    this.compareMatchesAndAction(prevProps.match, match)

    if (lang.isEmpty(orders)) {
      if (object.has(match.params, 'step')) {
        // const _item = collection.find(orders, (item, key) => {
        // return (item.dishId === match.params.id) && !item.confirmed;
        // });
        if (match.params.step !== undefined) {
          const path = `/category/set/${match.params.id}`
          history.push(path)
          console.info('route changed', path)
        }
      }
    } else {
      if (prevProps.match.params.id !== match.params.id) {
        const _order = collection.find(orders, (order, key) => {
          return (order.dishId === match.params.id) && !order.confirmed
        })

        if (_order) {
          const menuIndex = this.getMenuIndex(_order)
          if (menuIndex !== 0) {
            const path = `/category/set/${match.params.id}/${_order.steps[menuIndex].key}`
            history.push(path)
            console.info('route changed', path)
          }
        }
      } else {
        if (object.has(match.params, 'step')) {
          const _order = collection.find(orders, (order, key) => {
            return (order.dishId === match.params.id) && !order.confirmed
          })

          if (_order) {
            const swiperStepIndex = this.getSwiperStepIndex(_order)
            if (this.swiperWrapper) {
              this.swiperWrapper.swiper.slideTo(swiperStepIndex, 0)
            }
          } else {
            if (object.has(match.params, 'step')) {
              if (match.params.step !== undefined) {
                const path = `/category/set/${match.params.id}/`
                history.push(path)
                console.info('route changed', path)
              }
            }
          }
        }
      }
    }

    if (!object.has(match.params, 'step')) {
      window.removeEventListener('scroll', this.handleScroll)
    } else {
      window.addEventListener('scroll', this.handleScroll)
      const navBarSwiperSelector = document.querySelector('.navBar-swiper')
      const navBarSwiperDomElement = ReactDOM.findDOMNode(navBarSwiperSelector)

      if (!this.state.isRendered) {
        if (this.wrapRef.current && navBarSwiperDomElement) {
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState({
            isRendered: true,
          }, () => {
            this.setState({
              topOfClientRect: 47,
            })
          })
        }
      }
    }
  };

  renderPriceDiscount = (original, discount) => {
    const {
      classes,
    } = this.props
    const listPriceDiscountAmountStyle = cx(classes['list-price-discount-amount'])

    // discount === 0 ( NO Discount )
    // discount > 0 ( SHOW Discount )
    if (discount !== 0 && discount <= original) {
      return (
        <div className={listPriceDiscountAmountStyle}>
          <FontAwesomeIcon icon='dollar-sign' />
          {original}
        </div>
      )
    }
  };

  renderPricePrefix = (price) => {
    if (price && price !== 0 && price !== '0') {
      return (<FontAwesomeIcon icon='dollar-sign' />)
    }
  };

  renderPrice = (original, discount) => {
    const {
      classes,
    } = this.props
    const listPriceAmountStyle = cx(classes['list-price-amount'])
    const priceAmountStyle = (discount !== 0)
      ? { color: '#C54545' }
      : { color: '#614D4A' }

    // discount === 0 ( NO Discount )
    // discount > 0 ( SHOW Discount )
    if (original !== 0) {
      return (
        <span className={listPriceAmountStyle} style={priceAmountStyle}>
          {original - discount}
        </span>
      )
    }
  };

  renderPromoteTag = (isPromote) => {
    const {
      user,
      merchant,
      classes,
      intl,
    } = this.props

    const isWaiter = merchant && user && user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0

    if (isWaiter) {
      return
    }

    const _promoText = intl.formatMessage({ id: 'categoryDetailList.promo' })
    const listPromoteTagStyle = cx(classes['list-promo-tag'])
    if (isPromote) {
      return (
        <div className={listPromoteTagStyle}>
          {_promoText}
        </div>
      )
    }
  };

  renderStockAlertLevelTag = () => {
    const {
      classes,
      intl,
    } = this.props
    const SoldOutSoonText = intl.formatMessage(
      { id: 'soldOutSoon' },
    )
    return (
      <div className={cx(classes['list-stock-alert-tag'])}>
        {SoldOutSoonText}
      </div>
    )
  }

  selectTag = (tag) => {
    const {
      history,
      selectTag,
    } = this.props

    selectTag(tag)
    const path = {
      pathname: `/tag/${tag.name}`,
      state: {
        from: history.location.pathname,
      },
    }
    history.push(path)
    console.info('route changed', path)
  };

  sliderIndex = 1;
  slideChanged = (index) => {
    this.sliderIndex = index
  };

  renderSetSteps = (steps, setItem, setStep) => {
    const {
      classes,
      history,
      orders,
      match,
      activeSetStep,
      updateSetStep,
    } = this.props
    const {
      category,
    } = this.state

    const slideBlockWrapStyle = cx(classes['slide-block-wrap'])
    const slideActiveBlockWrapStyle = cx(classes['slide-block-wrap'], classes['slide-block-active'])
    const slideBlockStyle = cx(classes['slide-block'])
    const stepItemOverlayStyle = cx(classes['step-item-overlay'])
    const stepItemNameStyle = cx(classes['step-item-name'])
    const badgeWrapStyle = cx(classes['badge-wrap'])
    const badgeStyle = cx(classes.badge)
    const badgeDisableStyle = cx(classes['badge-disable'])

    const _order = collection.find(orders, (orderItem) => {
      return (orderItem.dishId === match.params.id) && !orderItem.confirmed
    })

    let currentStep = this.state.step
    if (!currentStep) {
      currentStep = setStep || steps[0]
    }

    return (steps
      .filter(step => {
        if (!step.dependsOnSetMenuItem && (!step.dependsOnSetMenuItems || step.dependsOnSetMenuItems.length === 0)) {
          return true
        }
        let nextStep = _.get(_order, 'items', []).map((i) => i.dishId).includes(step.dependsOnSetMenuItem)
	      _.get(_order, 'items', []).map((i) => i.dishId).some(o => {
	        if (step.dependsOnSetMenuItems && step.dependsOnSetMenuItems.includes(o)) {
	          nextStep = true
	          return true
	        }
          return false
	      })
	      return nextStep
      })
      .map((step, index) => {
        if (setStep === undefined && activeSetStep === undefined) {
          updateSetStep(0)
        } else if (step.key === currentStep.key) {
          updateSetStep(index)
        }

        let _displayOverlayStyle = ''
        let _stepQuantity = 0
        let badgeStepQuantity = ''

        if (!lang.isEmpty(_order)) {
          const _stepItem = collection.find(_order.steps, (item, key) => {
            return item.key === step.key
          })

          if (!lang.isEmpty(_stepItem)) {
            _stepQuantity = _stepItem.quantity
          }
        }

        if (!lang.isEmpty(setItem)) {
          if (index === 0) {
          // if first step
            _displayOverlayStyle = 'none'
          } else {
            const isAnyPrevStepNotFulFilled = setItem.steps.some((prevStep, prevStepIndex) => {
            // if there is any previous compulsory step has not been fulfilled
              return (prevStepIndex < index) && prevStep.setQuantity === 0 && !prevStep.optional
            })

            if (setItem.steps[index - 1] && setItem.steps[index - 1].setQuantity > 0 && isAnyPrevStepNotFulFilled) {
            // if the previous step has fulfilled a set requirement
              if (index - 1 === 0) {
              // if it is the second step
                _displayOverlayStyle = 'none'
              } else {
              // if steps other than first and second
                if (setItem.steps[index - 1].setQuantity === setItem.steps[index - 2].setQuantity) {
                // legacy logic for mulitple sets
                  _displayOverlayStyle = 'none'
                } else {
                // _displayOverlayStyle = 'block';
                }
              }
            } else if (activeSetStep >= index - 1) {
            // if active step is the previous step
              _displayOverlayStyle = 'none'
            } else if (!isAnyPrevStepNotFulFilled) {
            // if all previous steps requirement have been fulfilled
              _displayOverlayStyle = 'none'
            } else {
              _displayOverlayStyle = 'block'
            }
          }
        } else {
          if (index === 0) {
            _displayOverlayStyle = 'none'
          } else {
            const _order = collection.find(orders, (o) => {
              return (o.dishId === match.params.id) && !o.confirmed
            })

            if (!lang.isEmpty(_order)) {
              const _isEqualSetQuantity = _order.steps.every((val, key, arr) => {
                return (
                  arr[0].quantity >= arr[0].min &&
                (arr[0].max === 0 ? true : arr[0].quantity <= arr[0].max) &&
                val.setQuantity === arr[0].setQuantity
                )
              })

              if (_isEqualSetQuantity) {
                _displayOverlayStyle = 'none'
              } else {
                _displayOverlayStyle = 'block'
              }
            }
          }
        }
        // _stepQuantity
        if (_stepQuantity > 0) {
          badgeStepQuantity = (
            <div className={badgeWrapStyle}>
              <Badge
                className={
                  _displayOverlayStyle === 'none' ? badgeStyle : badgeDisableStyle
                }
                text={_stepQuantity}
              />
            </div>
          )
        }

        return (
          <div
            key={step.key}
            className={step.key === currentStep.key ? slideActiveBlockWrapStyle : slideBlockWrapStyle}
          >
            <div
              className={stepItemOverlayStyle}
              style={{ display: _displayOverlayStyle }}
            />
            <Flex
              justify='center'
              className={slideBlockStyle}
              onClick={() => {
                const path = `/category/set/${category.id}/${step.key}`
                history.push(path)
                console.info('route changed', path)
              }}
            >
              <div>
                {badgeStepQuantity}
                <div className={stepItemNameStyle}>
                  {index + 1}. {step.name}
                </div>
              </div>
            </Flex>
          </div>
        )
      }))
  };

  renderCategoryDescription = () => {
    const {
      classes,
      match,
      // history,
      orders,
    } = this.props
    const {
      category,
    } = this.state

    if (!lang.isEmpty(category)) {
      const listDescriptionWrapStyle = category.isSet ? cx(classes['list-description-wrap'], classes['list-set']) : cx(classes['list-description-wrap'])

      let desc
      if (!lang.isEmpty(category.desc)) {
        const listDescriptionStyle = cx(classes['list-description'])
        desc = (
          <Flex
            className={listDescriptionWrapStyle}
          >
            <Flex.Item className={listDescriptionStyle}>
              <div>
                {ReactHtmlParser(category.desc)}
              </div>
            </Flex.Item>
          </Flex>
        )
      }

      if (category.isSet) {
        const reactSwiperStyle = cx(classes['swiper-container'])
        const reactSwiperParams = {
          slidesPerView: 'auto',
          spaceBetween: 1,
          slideToClickedSlide: true,
          rebuildOnUpdate: true,
        }

        let setItem, setStep
        orders.some(order => {
          if (order.dishId === match.params.id && order.steps && !orders.confirmed) {
            const nextStep = order.steps.find((step) => {
              return (step.setQuantity < order.quantity)
            })
            if (nextStep) {
              setItem = order
              setStep = nextStep
              return true
            }
          }
          return false
        })

        return (
          <div
            style={{ width: '100%' }}
            ref={this.wrapRef}
          >
            {desc}
            <Flex
              className={listDescriptionWrapStyle}
            >
              <ReactSwiper
                {...reactSwiperParams}
                containerClass={reactSwiperStyle}
                ref={ref => {
                  this.swiperWrapper = ref
                }}
              >
                {this.renderSetSteps(category.steps, setItem, setStep)}
              </ReactSwiper>
            </Flex>
          </div>
        )
      }
    }
    return null
  };

  triggerSlideModal = (image, title, desc) => {
    const {
      triggerItemCoverImageModal,
    } = this.props

    triggerItemCoverImageModal(image, title, desc)()
  };

  renderItemDescription = (itemDesc) => {
    if (!lang.isEmpty(itemDesc)) {
      return (
        <ResponsiveEllipsis
          text={`${itemDesc}`}
          maxLine='3'
          ellipsis='...'
          trimRight
          basedOn='letters'
        />
      )
    } else {

    }
  };

  renderCategoryDetailListItems = () => {
    const {
      history,
      user,
      orders,
      classes,
      match,
      commodities,
      merchant,
      tags,
      categories,
      triggerItemCoverImageModal,
      intl,
      isSearchMode,
      updateSearchModeDisplay,
      menus,
      stepMin,
      stepMax,
      isTakeaway,
      isStoreDelivery,
    } = this.props
    let validMenus = menus
    // show only menus with valid category
    if (_.get(menus, 'length') && _.get(categories, 'length')) {
      validMenus = menus.filter(menu => {
        return _.flatten(categories.map(o => {
          return [o.id, ...o.categories.map(p => p.id)]
        })).includes(menu.categoryId)
      })
    }
    const searchCommodities = () => commodities.filter(commodity => {
      const searchText = this.state.searchText.toUpperCase()
      if (searchText === '@ALL') {
        return commodities //  display all commodities
      }
      if (searchText === '@SET') {
        return commodity.isSet
      }
      if (searchText !== '') {
        return commodity.name.toUpperCase().match(searchText) || (commodity.code && commodity.code.toUpperCase().match(searchText))
      }
    })

    const isWaiter = merchant && user && user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0

    const _noCategoryListText = intl.formatMessage({ id: 'categoryDetailList.no_category_list' })

    const gridContainerStyle = cx(classes['grid-container'])
    const listRightStyle = cx(classes['list-right'])
    const listAllStyle = cx(classes.list, classes['list-all'])
    const listStepperStyle = cx(classes['list-stepper'])

    if (lang.isNil(categories) || lang.isNil(validMenus)) {
      const activityIndicatorWrapStyle = cx(classes['activity-indicatior-wrap'])
      return (
        <div className={activityIndicatorWrapStyle}>
          <ActivityIndicator size='large' />
        </div>
      )
    }

    if (lang.isEmpty(match.params || match.params.id)) {
      return (
        <React.Fragment>
          <CarouselContainer
            promoItems={validMenus}
            activeIndex={this.sliderIndex}
            slideChange={this.slideChanged}
            triggerSlideImageModal={this.triggerSlideModal}
          />
          <div>
            <AboutContainer />
          </div>
          <div className={gridContainerStyle}>
            <GridContainer gridItems={tags} itemClick={this.selectTag} />
          </div>
        </React.Fragment>
      )
    }

    // > Render Search Mode
    if (isSearchMode) {
      const _searchText = intl.formatMessage({ id: 'searchText' })

      const waiterListStyle = cx(classes.list, classes['waiter-list'])
      const searchModeContainerStyle = cx(classes['search-mode-container'])
      const searchButtonContainerStyle = cx(classes['search-button-container'])
      const searchButtonStyle = cx(classes['search-button'])
      const searchBarContainerStyle = cx(classes['search-bar-container'])
      const searchBarInputStyle = cx(classes['search-bar-input'])
      const searchBarIconContainerStyle = cx(classes['search-bar-icon-container'])
      const waiterStepperItemsContainerStyle = cx(classes['waiter-stepper-items-container'])

      return (
        <div className={searchModeContainerStyle}>
          <div className={searchButtonContainerStyle}>
            <div
              className={searchButtonStyle}
              onClick={() => updateSearchModeDisplay(false)}
            >
              <FontAwesomeIcon icon={faTimesCircle} />
            </div>
          </div>
          {/**
            // > Search Bar
          */}
          <div className={searchBarContainerStyle}>
            <input
              ref={this.searchInputRef}
              autoFocus
              className={searchBarInputStyle}
              placeholder={_searchText}
              value={this.state.searchText}
              onChange={(e) => this.setState({ searchText: e.target.value })}
            />
            <div
              className={searchBarIconContainerStyle}
              onClick={() => {
                this.setState({ searchText: '' })
                this.searchInputRef.current.focus()
              }}
            >
              <FontAwesomeIcon icon={faUndo} />
            </div>
          </div>

          {/**
            // > Render Filtered Commodities
          */}
          <div className={waiterStepperItemsContainerStyle}>
            {searchCommodities().map((commodity, commodityIndex) => {
              const { merchant } = this.props
              const isSold = _.get(commodity, 'sold', false) || (merchant.setting.inventory && commodity.inventory === 0)

              return (
                <div
                  key={commodityIndex}
                  className={waiterListStyle}
                  style={{ margin: '0px', width: 'calc(100%/3)', boxShadow: 'none' }}
                >
                  <WaiterStepperContainer
                    commodity={commodity}
                    name={commodity.name}
                    itemName={commodity.name}
                    price={commodity.price}
                    priceUndetermined={commodity.priceUndetermined}
                    discount={commodity.discount}
                    category={this.state.category}
                    menuId={commodity.menuId}
                    itemId={commodity.id}
                    sold={isSold}
                    itemGroups={commodity.options}
                    setStep={this.state.step}
                    itemMax={commodity.max}
                    stepMin={stepMin}
                    stepMax={stepMax}
                    customizedCode={commodity.code}
                  />
                </div>
              )
            })}
          </div>
        </div>
      )
    }

    if (!lang.isEmpty(validMenus) && !lang.isEmpty(categories)) {
      let data = validMenus // > data = menus is all commodities (items) which under the same category (navbar's category).
      let stepMin
      let stepMax
      const step = this.state.step

      const currentStepKey = history.location.pathname.split('/').pop()
      const currentOrder = orders.reverse().find(order => order.steps && order.steps.find(step => step.key === currentStepKey))
      const firstStep = currentOrder && currentOrder.steps && currentOrder.steps[0]

      // if showing a set
      if (step) {
        // > if currentStep.overrideMinMax > 0, use it as multiplier.
        // > set both stepMin and stepMax to (firstStep.quantity * currentStep.overrideMinMax)
        if (step.overrideMinMax) {
          stepMin = firstStep && firstStep.quantity * step.overrideMinMax
          stepMax = firstStep && firstStep.quantity * step.overrideMinMax
        } else {
          stepMin = step.min
          stepMax = step.max
        }

        data = data.filter((m) => {
          return m.step === step.key // > data = find all the commodities (items) which is under current activeStep.
        })
      }

      //  if step is optional, append a "不需要" item
      if (step && step.optional) {
        const _notRequiredText = intl.formatMessage({ id: 'notRequired' })
        const notRequireData = {
          id: '0-' + step.key, // > id.startsWith('0-')) === isNotRequired
          name: _notRequiredText,
          price: 0,
          discount: 0,
          promoted: false,
          disabled: false,
          deleted: false,
          options: [],
        }

        if (merchant.setting.notRequiredAtBottom) {
          data.push(notRequireData)
        } else {
          data.unshift(notRequireData)
        }
      }

      const listPricePrefixStyle = cx(classes['list-price-prefix'])
      const listPriceAmountStyle = cx(classes['list-price-amount'])
      const listPriceUndeterminedStyle = cx(classes['list-price-undetermined'])
      const listItemNameStyle = cx(classes['list-item-name'])
      const listItemDescriptionStyle = cx(classes['list-item-description'])
      const listLeftWrapStyle = cx(classes['list-left-wrap'])

      return data.map((item, index) => {
        let listStyle = ''
        let listLeftStyle = ''
        let listPriceStyle = ''
        let itemBackgroundImageStyle = {}

        const itemDescription = !lang.isEmpty(item.desc) ? item.desc : undefined
        const priceAmountStyle = (item.discount !== 0)
          ? { color: '#C54545' }
          : { color: '#614D4A' }

        if (item.discount !== 0) {
          listLeftStyle = cx(classes['list-left'], classes['list-left-discount'])
          listPriceStyle = cx(classes['list-price'], classes['list-price-discount'])
        } else {
          listLeftStyle = cx(classes['list-left'])
          listPriceStyle = cx(classes['list-price'])
        }

        if (item.image) {
          if (isWaiter) {
            listStyle = cx(classes.list, classes['waiter-list'])
            itemBackgroundImageStyle = { boxShadow: 'none' }
          } else {
            listStyle = cx(classes.list, classes['list-background-image'])
            itemBackgroundImageStyle = {
              backgroundImage: cloudinary.transformation(`url(${item.image})`, `w_${IPHONEX_WIDTH}`),
              backgroundPosition: 'center center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            }
          }
        } else {
          if (isWaiter) {
            listStyle = cx(classes.list, classes['waiter-list'])
            itemBackgroundImageStyle = { boxShadow: 'none', background: 'white' }
          } else {
            listStyle = cx(classes.list)
            itemBackgroundImageStyle = {}
          }
        }

        const isSold = _.get(item, 'sold', false) || (merchant.setting.inventory && item.inventory === 0)

        const _undeterminedPriceText = intl.formatMessage({ id: 'summary.undetermined.price' }) // 時價

        const listLeft = !isWaiter && (
          <Flex.Item className={listLeftStyle}>
            <div
              className={listLeftWrapStyle}
              ref={ref => {
                if (!lang.isEmpty(ref)) {
                  const _offsetHeight = ref.offsetHeight
                  if (_offsetHeight > this.defaultItemNameHeight && item.promoted) {
                    ref.style.paddingTop = '15px'
                  } else {
                    ref.style.paddingTop = '0px'
                  }
                }
              }}
            >
              <div className={listItemNameStyle}>
                {item.name}
              </div>
              <div className={listItemDescriptionStyle}>
                {this.renderItemDescription(itemDescription)}
              </div>

            </div>
          </Flex.Item>
        )
        let discount = item.discount
        let price = item.price
        const takeawayPrice = (item.prices || []).find(p => p.type === 'takeaway')
        const deliveryPrice = (item.prices || []).find(p => p.type === 'storeDelivery') || takeawayPrice
        if (isTakeaway) {
          if (isStoreDelivery) {
            discount = deliveryPrice ? deliveryPrice.discount : item.discount
            price = deliveryPrice ? deliveryPrice.price : item.price
          } else {
            discount = takeawayPrice ? takeawayPrice.discount : item.discount
            price = takeawayPrice ? takeawayPrice.price : item.price
          }
        }
        const listRight = !isWaiter && (
          <Flex.Item className={listRightStyle}>
            <ul>
              <li
                className={listStepperStyle}
                onClick={(e) => e.stopPropagation()}
              >
                <StepperContainer
                  key={item.id + this.props.selectedSetCategory}
                  menuId={item.menuId}
                  item={{ ...item, price, discount }}
                  itemId={item.id}
                  itemName={item.name}
                  itemPrice={price}
                  itemGroups={item.options}
                  itemDiscount={discount}
                  itemMax={item.max}
                  category={this.state.category}
                  setStep={this.state.step}
                  isSold={isSold}
                  stepMin={stepMin}
                  stepMax={stepMax}
                  priceUndetermined={item.priceUndetermined}
                />
              </li>
              <li className={listPriceStyle}>

                {this.renderPriceDiscount(price, discount)}

                <div className={listPricePrefixStyle}>
                  {this.renderPricePrefix(price)}
                </div>
                {!item.priceUndetermined && (
                  <div
                    className={listPriceAmountStyle}
                    style={priceAmountStyle}
                  >
                    {this.renderPrice(price, discount)}
                  </div>
                )}
                {item.priceUndetermined &&
                  <div className={listPriceUndeterminedStyle}>
                    {_undeterminedPriceText}
                  </div>}
              </li>
            </ul>
          </Flex.Item>
        )

        const result = isWaiter
          ? (
            <div key={index} className={listStyle} style={{ margin: '0px', width: 'calc(100%/3)', boxShadow: 'none' }}>
              <WaiterStepperContainer
                name={item.name}
                itemName={item.name}
                price={item.price}
                priceUndetermined={item.priceUndetermined}
                discount={item.discount}
                category={this.state.category}
                menuId={item.menuId}
                itemId={item.id}
                sold={isSold}
                itemGroups={item.options}
                setStep={this.state.step}
                itemMax={item.max}
                stepMin={stepMin}
                stepMax={stepMax}
              />
            </div>
          )
          : (
            <React.Fragment key={index}>
              <Flex
                className={listStyle}
                style={{ ...itemBackgroundImageStyle }}
                onClick={triggerItemCoverImageModal(item.image, item.name, item.desc)}
              >
                {this.renderPromoteTag(item.promoted)}
                {listLeft}
                {listRight}
                {
                  merchant.setting.inventory &&
                  item.inventory <= item.stockAlertLevel &&
                  item.inventory > 0 &&
                  !isSold &&
                  this.renderStockAlertLevelTag()
                }
              </Flex>
            </React.Fragment>
          )

        return result
      })
    } else {
      return (
        <Flex className={listAllStyle}>
          <Flex.Item>
            {_noCategoryListText}
          </Flex.Item>
        </Flex>
      )
    }
  };

  render () {
    const { user, merchant, classes } = this.props
    const isWaiter = merchant && user && user.permissions && user.permissions.indexOf(merchant.id + ':waiter') >= 0
    const waiterStepperItemsContainerStyle = cx(classes['waiter-stepper-items-container'])
    return (
      isWaiter
        ? (
          <React.Fragment>
            {this.renderCategoryDescription()}
            <div className={waiterStepperItemsContainerStyle}>
              {this.renderCategoryDetailListItems()}
            </div>
          </React.Fragment>
        )
        : (
          <React.Fragment>
            {this.renderCategoryDescription()}
            {this.renderCategoryDetailListItems()}
          </React.Fragment>
        )
    )
  }
};

/**
 * Export
 */
export default injectSheet(styles)(CategoryDetailList)



// WEBPACK FOOTER //
// ./src/components/CategoryDetailList.js